import { useTranslation } from "react-i18next";

import { Pill } from "@aviary";
import { useSharedGlobalConfig, useUnauthedExperiment } from "@shared/hooks";
import type { PatientAttributes } from "@unauthenticated/signupSignin/data/types";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./StoreOffersPill.styles";
interface Props {
  patientAttributes: PatientAttributes;
}

const StoreOffersPill = ({ patientAttributes }: Props) => {
  const { t } = useTranslation();
  const { isUS } = useSharedGlobalConfig();
  const { discount, storeDiscount } = patientAttributes;

  const discountPillExperimentGroup = useUnauthedExperiment({
    experiment: "titan_discount_pill_experiment",
    groups: ["CONTROL", "EXPERIMENT"],
    // Only log experiment on sign up pages if storeDiscount is greater than 0.
    // Sign up pages won't have discount defined, but will have storeDiscount defined.
    shouldLog: !discount && storeDiscount > 0,
  });

  const renderDiscountPill = () => {
    const discountToDisplay =
      discount || (discountPillExperimentGroup === "EXPERIMENT" && storeDiscount);

    if (!discountToDisplay) return null;

    return (
      <Pill isColor="success" css={styles.pill}>
        {t(l.sharedCommon.discountPill, { discount: discountToDisplay })}
      </Pill>
    );
  };

  const renderFreeShipping = () =>
    !isUS ? t(l.patientRxAuth.FreeShippingCA) : t(l.patientRxAuth.FreeShippingUS);

  return (
    <div css={styles.pillContainer}>
      {renderDiscountPill()}
      <Pill isColor="success" css={styles.pill}>
        {renderFreeShipping()}
      </Pill>
    </div>
  );
};

export { StoreOffersPill };
